import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientQLCollectionQuery, ClientQLCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientQLCollectionQuery)
@Wrapper(ClientQLCollectionQueryHandlerBase)
export class ClientQLCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
